import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Paper,
  Alert,
  Typography,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";

const ForgotPassForm = () => {
  const [cuit, setCuit] = useState("");
  const [mail, setMail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { sendRecoveryEmail } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      await sendRecoveryEmail(cuit, mail);
      setMessage("Se ha enviado un correo para restablecer tu contraseña.");
    } catch (err) {
      setError(err.message || "Ocurrió un error al enviar el correo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        bgcolor: '#FBF7EF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 3,
          backgroundColor: "#fafafa",
          width: '100%',
          maxWidth: 400,
          mx: 2,
        }}
      >
        <Typography
          variant="h5"
          align="center"
          sx={{ color: '#003B23', fontWeight: 600, mb: 2 }}
        >
          Recuperar contraseña
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {message && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            label="CUIT"
            variant="outlined"
            fullWidth
            margin="normal"
            value={cuit}
            onChange={(e) => setCuit(e.target.value)}
            required
            sx={{
              '& label.Mui-focused': { color: '#698577' },
              '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: '#698577',
              },
            }}
          />

          <TextField
            label="Correo electrónico"
            type="email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={mail}
            onChange={(e) => setMail(e.target.value)}
            required
            sx={{
              '& label.Mui-focused': { color: '#698577' },
              '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: '#698577',
              },
            }}
          />

          {loading && (
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#003B23" }}>
              Enviando correo...
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              backgroundColor: '#003B23',
              '&:hover': {
                backgroundColor: '#3b7b61',
              },
            }}
          >
            Recuperar contraseña
          </Button>

          {/* Asegura funcionamiento con Enter */}
          <button type="submit" style={{ display: 'none' }} aria-hidden="true" />
        </Box>
      </Paper>
    </Box>
  );
};

export default ForgotPassForm;
